import {
  ShieldCheck,
  HeartHandshake,
  Armchair,
  Lock,
  MapPin,
  PhoneCall,
  Navigation,
} from "lucide-react";

const reasons = [
  {
    icon: HeartHandshake,
    title: "Peaceful & disciplined environment",
    desc: "A quiet ecosystem where serious learners thrive without distractions.",
  },
  {
    icon: ShieldCheck,
    title: "Designed for serious students",
    desc: "From UPSC to coding bootcamps — built for long, focused sessions.",
  },
  {
    icon: Armchair,
    title: "Comfortable study seating",
    desc: "Ergonomic chairs, individual desks, pinboards & ample personal space.",
  },
  {
    icon: Lock,
    title: "Safe & secure premises",
    desc: "CCTV monitored, gated access, and personal lockers for your essentials.",
  },
  {
    icon: MapPin,
    title: "Multiple branches in Noida",
    desc: "Sector 22 & Sector 26 — choose what works best for your commute.",
  },
  {
    icon: PhoneCall,
    title: "Easy contact via call & WhatsApp",
    desc: "Reach us instantly — book a tour, ask a question, get a seat.",
  },
  {
    icon: Navigation,
    title: "Google Maps directions available",
    desc: "Find us in seconds with one-tap navigation from anywhere.",
  },
];

export default function WhyChoose() {
  return (
    <section
      data-testid="why-choose-section"
      className="relative py-24 md:py-32 bg-[#0F0F0F]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.25em] uppercase text-[#FACC15] font-semibold mb-4">
              Why Justudy
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight font-semibold text-white leading-[1.05]">
              Built around
              <br />
              <span className="text-[#FACC15] italic font-light">
                your discipline.
              </span>
            </h2>
            <p className="mt-6 text-white/60 leading-relaxed max-w-md">
              We don&apos;t just rent desks. We engineer environments where focus
              becomes the default and progress is the only outcome.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {reasons.map((r, i) => {
              const I = r.icon;
              return (
                <div
                  key={i}
                  data-testid={`reason-${i}`}
                  className="group bg-[#1A1A1A] hover:bg-[#211E1A] border border-white/5 hover:border-[#FACC15]/30 p-5 md:p-6 rounded-sm transition-all"
                >
                  <I className="w-6 h-6 text-[#FACC15] mb-4" />
                  <div className="font-display text-base font-semibold text-white mb-1.5">
                    {r.title}
                  </div>
                  <div className="text-xs text-white/55 leading-relaxed">
                    {r.desc}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
